import React from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';
import { StylableComponent, stylePropType } from '@adsk/alloy-react-theme';

type PanelBodyProps = StylableComponent<HTMLDivElement>;

const PanelBody = React.forwardRef<HTMLDivElement, PanelBodyProps>(
  ({ children, className, style, ...props }, ref) => {
    const dynamicTheme = useTheme();

    return (
      <div
        ref={ref}
        className={className}
        css={[
          {
            overflow: 'auto',
            flexGrow: 1,
          },
          dynamicTheme.tokens?.component?.panel?.child,
          style,
        ]}
        {...props}
      >
        {children}
      </div>
    );
  },
);

PanelBody.displayName = 'PanelBody';

PanelBody.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Body content */
  children: PropTypes.any,
  /** Class applied to the root element */
  className: PropTypes.string,
};

export default PanelBody;
